import { Tooltip, IconButton, Icon } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export interface ReloadIconButtonProps {
  action: () => void;
}

function ReloadIconButton({ action }: ReloadIconButtonProps) {
  const { t } = useTranslation();

  return (
    <Tooltip arrow title={t('f-reload')}>
      <IconButton color="primary" onClick={action}>
        <Icon>{'refresh'}</Icon>
      </IconButton>
    </Tooltip>
  );
}

export default ReloadIconButton;
